module.exports = ".cardrow\n{\n  padding: 10px\n}"